import React, { Fragment } from 'react'
import ReCAPTCHA from "react-google-recaptcha";

type FieldValues = {
  sitekey: string, 
  error: any,
  onChange: any
};

const FieldCaptcha: React.FC<FieldValues> = ({ sitekey, error, onChange }) => {
  const handleChange = (e: any) => {
    onChange(e);
  }
  return (
    <Fragment>
      <div className='i-form-group'>
        <ReCAPTCHA 
          sitekey={sitekey}
          onChange={handleChange}
        />
        {error ? <div className="i-form-group-text i-has-error">{error.message || 'You must prove that you are human'}</div> : ''}
      </div>
    </Fragment>
  )
}

export default FieldCaptcha
